'use client'
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";

// src/components/text/ContentfulRichText.tsx
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { jsx } from "react/jsx-runtime";
var ContentfulRichText = ({ description }) => {
  const { json, links } = description;
  return documentToReactComponents(json, {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        return /* @__PURE__ */ jsx("a", { href: node.data.uri, className: "text-primary hover:underline", children });
      },
      [BLOCKS.UL_LIST]: (_, children) => {
        return /* @__PURE__ */ jsx("ul", { className: "list-disc ltr:ml-4 rtl:mr-4", children });
      },
      [BLOCKS.OL_LIST]: (_, children) => {
        return /* @__PURE__ */ jsx("ol", { className: "list-decimal ltr:ml-4 rtl:mr-4", children });
      },
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        var _a, _b, _c, _d;
        const assetId = node.data.target.sys.id;
        const asset = (_b = (_a = links == null ? void 0 : links.assets) == null ? void 0 : _a.block) == null ? void 0 : _b.find((asset2) => asset2.sys.id === assetId);
        if (((_c = asset == null ? void 0 : asset.contentType) == null ? void 0 : _c.includes("video")) || ((_d = asset == null ? void 0 : asset.contentType) == null ? void 0 : _d.includes("image"))) {
          return /* @__PURE__ */ jsx(ContentfulMedia_default, { media: asset, controls: true });
        }
        return null;
      }
    }
  });
};
var ContentfulRichText_default = ContentfulRichText;

export {
  ContentfulRichText_default
};
//# sourceMappingURL=chunk-DR2RGIIC.mjs.map